import { create } from "zustand";
import { TerminalStoreProps } from "./interface/terminal-store.interface";
import {
  getChemProperty,
  getEmissionControl,
  getFilterChemProperty,
  getFilterEmissionControl,
  getFilterLoadingMethod,
  getLoadingMethod,
} from "src/services/settings.service";

export const terminalStore = create<TerminalStoreProps>((set) => ({
  loadingChemical: false,
  chemicalProperty: [],
  filterChemProperty: [],
  loadingMethod: [],
  filterLoadingMethod: [],
  emissionControl: [],
  filterEmissionControl: [],
  totalChemProp: 0,
  totalLoading: 0,
  totalEmissionControl: 0,
  getChemicalProperty: async (query: string) => {
    try {
      const response = await getChemProperty(query);
      set(() => ({
        loadingChemical: false,
        chemicalProperty: response.data?.data.data ?? [],
        totalChemProp: response.data?.data.total ?? 0,
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getFilterChemicalProperty: async () => {
    try {
      const response = await getFilterChemProperty();
      set(() => ({
        filterChemProperty: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getLoadingMethod: async (query: string) => {
    try {
      const response = await getLoadingMethod(query);
      set(() => ({
        totalLoading: response.data?.data.total ?? 0,
        loadingMethod: response.data?.data.data ?? [],
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getFilterLoadingMethod: async () => {
    try {
      const response = await getFilterLoadingMethod();
      set(() => ({
        filterLoadingMethod: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    } finally {
    }
  },
  getEmissionControl: async (query: string) => {
    try {
      const response = await getEmissionControl(query);
      set(() => ({
        totalEmissionControl: response.data?.data.total ?? 0,
        emissionControl: response.data?.data.data ?? [],
      }));
    } catch (error) {
      console.error(error);
    }
  },
  getFilterEmissionControl: async () => {
    try {
      const response = await getFilterEmissionControl();
      set(() => ({
        filterEmissionControl: response.data.data.filter ?? [],
      }));
    } catch (error) {
      console.error(error);
    }
  },
}));
